export function formatArs(value: number): string {
  return `$${value.toLocaleString('es-AR')}`
}
